import React from "react";

/**
 * ─── Spinner ──────────────────────────────────────────────────────────────
 * The single loading indicator (PDR §8, P2 shipped early in Gate 1.5).
 * Prefer skeletons for page/section loads; use Spinner only inside buttons
 * or as a tiny inline signal.
 */
export default function Spinner({ size = "md", label = "Loading…", testId }) {
  return (
    <span className={`ds-spinner ds-spinner--${size}`} role="status"
          aria-label={label} data-testid={testId} />
  );
}
